import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d3eb1f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=5d3eb1f8&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=5d3eb1f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3eb1f8",
  null
  
)

export default component.exports